import { render, staticRenderFns } from "./Returns.vue?vue&type=template&id=7aaa9245"
import script from "./Returns.vue?vue&type=script&setup=true&lang=js"
export * from "./Returns.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports